var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37919 5.00966C8.59886 5.22933 8.59886 5.58549 8.37919 5.80516L4.83944 9.34491H15.4814C15.7921 9.34491 16.0439 9.59675 16.0439 9.90741C16.0439 10.2181 15.7921 10.4699 15.4814 10.4699H4.83944L8.37919 14.0097C8.59886 14.2293 8.59886 14.5855 8.37919 14.8052C8.15952 15.0248 7.80337 15.0248 7.5837 14.8052L3.0837 10.3052C2.86403 10.0855 2.86403 9.72933 3.0837 9.50966L7.5837 5.00966C7.80337 4.78999 8.15952 4.78999 8.37919 5.00966Z",
    fill: "#1E2D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBackArrow);
export default __webpack_public_path__ + "static/media/left_back_arrow.e708e480459709738cc98c848daa7b76.svg";
export { ForwardRef as ReactComponent };